import {Pipe, PipeTransform} from "@angular/core";
import {RuntimeStatus} from "src/enums/runtime-status.enum";
@Pipe({
    name: "runtimeStatus",
    standalone: false
})
export class RuntimeStatusPipe implements PipeTransform {
    constructor() { }

    transform(value?: number): string | void {
        if (typeof value === 'undefined' || value < -1) return;

        return RuntimeStatus[value];
    }
}
